import { API } from '@/api';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getSignUpAllowed = createAsyncThunk('signUpAllowed/get', API.signUpAllowed.get);

export const addSignUpAllowed = createAsyncThunk(
  'signUpAllowed/add',
  async ({ type, allowed }: { type: 'domains' | 'emails'; allowed: string }) =>
    API.signUpAllowed.add({ type, allowed }),
);

export const deleteSignUpAllowed = createAsyncThunk(
  'signUpAllowed/delete',
  async ({ type, allowed }: { type: 'domains' | 'emails'; allowed: string }) =>
    API.signUpAllowed.remove({ type, allowed }),
);
